<div class="form-component">

    <h4>
        Auto-Matching
    </h4>

    <table>
        <thead>
            <tr>
                <th width="50%;">Task</th>
                <th width="10%">Quantity</th>
                <th width="10%">Status</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td><strong>Total Records To Match</strong></td>
                <td>{{ matchCounts.RecordsToProcess }}</td>
                <td></td>
            </tr>
            <tr>
                <td>Matches By Customer Name &amp; Code</td>
                <td>{{ matchCounts.CustomerNameAndCode }}</td>
                <td [ngClass]="stepStatuses.CustomerNameAndCode === 'Done' ? 'status done' : 'status'">
                    {{ stepStatuses.CustomerNameAndCode }}
                    <span *ngIf="stepStatuses.CustomerNameAndCode != 'Done'" class="loading-spinner"></span>
                </td>
            </tr>
            <tr>
                <td>Matches By Historical Records</td>
                <td>{{ matchCounts.Historical }}</td>
                <td [ngClass]="stepStatuses.Historical === 'Done' ? 'status done' : 'status'">
                    {{ stepStatuses.Historical }}
                    <span *ngIf="stepStatuses.Historical != 'Done'" class="loading-spinner"></span>
                </td>
            </tr>
            <tr>
                <td>Matches By Ageing Reference Number</td>
                <td>{{ matchCounts.AgeingReference }}</td>
                <td [ngClass]="stepStatuses.AgeingReference === 'Done' ? 'status done' : 'status'">
                    {{ stepStatuses.AgeingReference }}
                    <span *ngIf="stepStatuses.AgeingReference != 'Done'" class="loading-spinner"></span>
                </td>
            </tr>
            <tr>
                <td>Matches By Annexure Reference Number</td>
                <td>{{ matchCounts.AnnexureReference }}</td>
                <td [ngClass]="stepStatuses.AnnexureReference === 'Done' ? 'status done' : 'status'">
                    {{ stepStatuses.AnnexureReference }}
                    <span *ngIf="stepStatuses.AnnexureReference != 'Done'" class="loading-spinner"></span>
                </td>
            </tr>
            <tr>
                <td>Matches By Debtor/Customer Name</td>
                <td>
                    {{ matchCounts.CustomerName }}
                </td>
                <td [ngClass]="stepStatuses.CustomerName === 'Done' ? 'status done' : 'status'">
                    {{ stepStatuses.CustomerName }}
                    <span *ngIf="stepStatuses.CustomerName != 'Done'" class="loading-spinner"></span>
                </td>
            </tr>
            <tr>
                <td>Matches By Debtor/Customer Registration Number</td>
                <td>{{ matchCounts.RegistrationNumber }}</td>
                <td [ngClass]="stepStatuses.RegistrationNumber === 'Done' ? 'status done' : 'status'">
                    {{ stepStatuses.RegistrationNumber }}
                    <span *ngIf="stepStatuses.RegistrationNumber != 'Done'" class="loading-spinner"></span>
                </td>
            </tr>
            <tr>
                <td><strong>Total Records Matched</strong></td>
                <td>{{ matchCounts.Matched }}</td>
                <td></td>
            </tr>
            <tr>
                <td><strong>Total Unmatched Records</strong></td>
                <td>{{ matchCounts.Unmatched }}</td>
                <td></td>
            </tr>
        </tbody>
    </table>
</div>

